<script setup lang="ts">
defineProps<{
  icon?: string
  message?: string
}>()
</script>

<template>
  <Card class="text-center py-8">
    <Icon
      :name="icon || 'i-heroicons-chat-bubble-bottom-center-text'"
      class="w-12 h-12 mx-auto text-gray-400 mb-4"
    />
    <p class="text-gray-600">
      {{ message || "No data available" }}
    </p>
  </Card>
</template>
